import { superstyled } from '@zenbusiness/zui/styles';

export const Site = superstyled({
  name: 'AppContainer',
  slot: 'Site',
  styles: ({ theme }) => ({
    position: 'relative',
    transition: theme.transitions.create(['transform'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),

    [theme.breakpoints.up('md')]: {
      height: '100dvh',
      maxHeight: '100dvh',
      overflow: 'hidden'
    }
  })
});

export const Page = superstyled({
  name: 'AppContainer',
  slot: 'Page',
  styles: ({ theme }) => ({
    display: 'grid',
    gridTemplateRows: 'auto minmax(0, 1fr) auto',
    gridTemplateAreas: `
      "app-container-header"
      "app-container-main"
    `,
    height: '100%',
    maxWidth: '100%',
    [theme.breakpoints.up('md')]: {}
  })
});

export const Header = superstyled({
  name: 'AppContainer',
  slot: 'Header',
  propsAdded: {
    component: 'header',
    id: 'app-container-header'
  },
  styles: ({ theme }) => ({
    background: theme.palette.fixed.grey[950],
    gridArea: 'app-container-header'
  })
});

export const Main = superstyled({
  name: 'AppContainer',
  slot: 'Main',
  propsAdded: {
    component: 'main',
    id: 'app-container-main'
  },
  styles: ({ theme }) => ({
    gridArea: 'app-container-main',
    minHeight: '100%',
    overflowX: 'hidden', // Ensure no horizontal overflow. Watch out for Wistia Video on mobile.
    width: '100%',

    paddingBlockStart: theme.spacing(2),
    paddingBlockEnd: theme.spacing(6),
    [theme.breakpoints.up('md')]: {
      paddingBlockStart: theme.spacing(3),
      paddingBlockEnd: theme.spacing(10)
    }
  })
});
